import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Roboto-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

Font.register({
  family: "Oswald",
  src: "/fonts/Oswald-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Oswald-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    gap: 10,
    backgroundColor: "#fff",
    fontFamily: "Roboto",
    padding: 10,
  },
  section: {
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
    padding: 10,
  },
  titleText: {
    fontFamily: "Oswald",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
  },
  subtitleText: {
    fontFamily: "Roboto",
    textAlign: "center",
    fontWeight: "normal",
    fontSize: 12,
  },
  normalText: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal",
    textAlign: "left",
  },
  tableView: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 5,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    backgroundColor: "#ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "normal",
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
});

export default function RetiradaReforcoPDF({
  data,
  codigoCartao,
  totalCredito,
  totalDebito,
}) {
  const totalRetirada = data
    .filter((row) => row.TIPO === "R")
    .reduce((sum, row) => sum + row.VALOR, 0);

  const totalReforco = data
    .filter((row) => row.TIPO !== "R")
    .reduce((sum, row) => sum + row.VALOR, 0);

  return (
    <Document
      creationDate={new Date()}
      author="Santa Ficha"
      title={`Retirada e Reforço - ${new Date().toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })}`}
      subject="Retirada e Reforço"
      keywords="relatório, retirada, reforço, santa ficha"
      producer="Santa Ficha"
      creator="Santa Ficha"
      language="pt-BR"
    >
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.titleText}>
            Retirada e Reforço
          </Text>
          <Text style={styles.subtitleText}>
            Emitido em{" "}
            {new Date().toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Text>
        </View>

        <View style={styles.tableView}>
          <View style={styles.tableHeader}>
            <Text style={{ width: "30%" }}>Data/Hora</Text>
            <Text style={{ width: "30%" }}>Descrição</Text>
            <Text style={{ width: "10%" }}>Tipo</Text>
            <Text style={{ width: "10%" }}>PDV</Text>
            <Text style={{ width: "10%" }}>Turno</Text>
            <Text style={{ width: "10%", textAlign: "right" }}>Valor</Text>
          </View>

          {data?.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={{ width: "30%" }}>
                {new Intl.DateTimeFormat("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(row?.DATAHORA))}
              </Text>
              <Text style={{ width: "30%" }}>{row?.DESCRICAO}</Text>
              <Text style={{ width: "10%" }}>
                {row.TIPO === "R" ? "Retirada" : "Reforço"}
              </Text>
              <Text style={{ width: "10%" }}>{row?.CODPDV}</Text>
              <Text style={{ width: "10%", textAlign: "right" }}>
                {row?.TURNO}
              </Text>
              <Text style={{ width: "10%", textAlign: "right" }}>
                {Number(row.VALOR).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
            </View>
          ))}

          <View style={styles.tableHeader}>
            <Text style={{ width: "20%" }}></Text>
            <Text style={{ width: "20%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "5%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "20%", textAlign: "right" }}>
              Total Retirada:
            </Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              {totalRetirada?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>

          <View style={styles.tableHeader}>
            <Text style={{ width: "20%" }}></Text>
            <Text style={{ width: "20%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "5%" }}></Text>
            <Text style={{ width: "20%", textAlign: "right" }}>
              Total Reforço:
            </Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              {totalReforco?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
